<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="author"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        flat
        clearable
        v-model="item.author"
        :items="optionUserItems"
        text-field="username"
        value-field="id"
        :validator="$v.item[schema.fields.author.name]"
        :loading="optionUserWorking"
        name="author"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.author"
        :form-state="formState"
        readonly
      ></o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="title"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.title"
        :form-state="formState"
        name="title"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.title"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="body"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-html-area
        v-model="item.body"
        :form-state="formState"
        name="body"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.body"
      ></o-html-area>
    </o-widget-wrapper>

    <o-form-group>
      <b-button-group>
        <b-button @click="selectAllTypes()">Select All</b-button>
        <b-button @click="unselectAllTypes()">Unselect All</b-button>
      </b-button-group>
    </o-form-group>

    <o-widget-wrapper
      :schema="schema"
      name="employee_type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-multi-checkbox
        v-model="item.employee_type"
        :items="filteredCodeEmployeeTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        :loading="optionCodeEmployeeTypeWorking"
        name="code_employee_type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.employee_type"
      >
      </o-multi-checkbox>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import OMultiCheckbox from "../../../vue-ocom/components/forms/fields/OMultiCheckbox";

// import { default as UserForm } from '../../user/components/ItemForm';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Post"),
    CreateCodeTableFetchMixin(["User", "CodeEmployeeType"]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    OMultiCheckbox,

    /* UserForm, */
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Post, {}),
  }),
  methods: {
    selectAllTypes() {
      this.$emit("select-all");
    },
    unselectAllTypes() {
      this.$emit("unselect-all");
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    filteredCodeEmployeeTypeItems() {
      // Remove items that start with 'z' or 'Z'
      var result = [];

      this.optionCodeEmployeeTypeItems.forEach((item) => {
        if (item.description[0] !== "z" && item.description[0] !== "Z") {
          result.push(item);
        }
      });

      return result;
    },
  },
  watch: {},
  created() {},
};
</script>
